import { useState } from 'react';
import { Flex, ProgressCircle, Content, TableView, TableHeader, TableBody, Column, Row, Cell, Link, View, ActionButton } from '@adobe/react-spectrum';
import { useTranslation } from 'react-i18next';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import styles from './EventListTable.module.css';
import { EditIcon } from '../../../../components/protected/Icons/IconsLib';
interface IEventListTableProps {
    upComming7DaysEvents: any,
    past7DaysCompleted: any,
    past3MonthsUnCompleted: any,
    handleTableRowclick: (tableRow: any) => void;
    handleAddNew?: () => void;
    isShowAddEditButton?: boolean
    handleTableRowClick?: (data: any) => void;
    handleEditClick?: (data: any) => void;
    handleDeleteClick?: (data: any) => void;
}

const EventListTable: React.FC<IEventListTableProps> = ({
    upComming7DaysEvents,
    past7DaysCompleted,
    past3MonthsUnCompleted,
    handleTableRowclick,
    handleAddNew,
    isShowAddEditButton,
    handleTableRowClick,
    handleEditClick }) => {
    const { t } = useTranslation('calendar');
    const _t = (key: string) => t(`add_update_event.${key}`, { ns: 'calendar' });
    let columnsData = [
        {
            key: 'icon',
            name: '',
            width: 50,
        },
        {
            key: 'dateTo',
            name: t('date', { ns: 'layout_components' }),
            width: 170,
        },
        {
            key: 'solutionStatus',
            name: t('status', { ns: 'layout_components' }),
            width: null,
        },
        {
            key: 'title',
            name: t('subject', { ns: 'layout_components' }),
            width: null,
        },
        {
            key: 'userList',
            name: t('user', { ns: 'layout_components' }),
            width: null,
        },
        {
            key: 'entryTypeName',
            name: t('type_of_work', { ns: 'layout_components' }),
            width: null,
        },
        { name: '', key: 'edit', width: 15 },
    ];

    let columnsDataMobile = [
        {
            key: 'icon',
            name: '',
            width: 25,
        },
        {
            key: 'dateTo',
            name: t('date', { ns: 'layout_components' }),
            width: 170,
        },
        {
            key: 'solutionStatus',
            name: t('status', { ns: 'layout_components' }),
            width: 150,
        },
        {
            key: 'title',
            name: t('subject', { ns: 'layout_components' }),
            width: 250,
        },
        {
            key: 'userList',
            name: t('user', { ns: 'layout_components' }),
            width: 250,
        },
        {
            key: 'entryTypeName',
            name: t('type_of_work', { ns: 'layout_components' }),
            width: 150,
        },
        { name: '', key: 'edit', width: 15 },
    ];

    const { isMobile } = useViewInfo();
    const [showLoader, setShowLoader] = useState(false);

    if (showLoader) {
        return (
            <Flex width="100%" justifyContent={'center'} marginTop={10}>
                <ProgressCircle aria-label="Loading…" isIndeterminate />
            </Flex>
        );
    } else {
        return (
            <Flex UNSAFE_style={{ padding: '10px'}} UNSAFE_className={styles.tables_scroll_container} direction={'column'} gap={'size-150'} position={'relative'} width={'100%'} >
                <>
                    <Flex direction={'row'} alignItems={'start'} justifyContent={'start'}>
                        <Content position={'relative'} UNSAFE_className={styles.heading_text}>
                            Upcoming 7 Days
                        </Content>
                        <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'size-100'} UNSAFE_className={styles.icon_add_parent}>
                            <>
                                <Content>
                                    <Link
                                        isHidden={!isShowAddEditButton}
                                        isQuiet
                                        onPress={e => {
                                            // defaultRowData.userId = String(store.UserId);
                                            // setSelectedRow(defaultRowData);
                                            // handleUnselect();
                                            handleAddNew && handleAddNew();
                                        }}
                                    >
                                        <i className="bi bi-plus fs-5">
                                            <View UNSAFE_className={styles.icon_add_text}>{_t('add_event')} </View>
                                        </i>
                                    </Link>
                                </Content>
                                {/* <Content>
                                              <Link
                                                isQuiet
                                                onPress={e => {
                                                  // defaultRowData.userId = String(store.UserId);
                                                  // setSelectedRow(defaultRowData);
                                                  // handleUnselect();
                                                  // setShowAddEditRow(true);
                                                  // isMobile && setIsOpen(true);
                                                }}
                                              >
                                                <i className="bi bi-plus fs-5">
                                                  <View UNSAFE_className={styles.icon_add_text}>{t('quick_task', { ns: 'layout_components' })} </View>
                                                </i>
                                              </Link>
                                            </Content> */}
                            </>
                        </Flex>
                    </Flex>
                    <Flex direction={'column'}>
                        <TableView
                            UNSAFE_className="tblLayoutComponent"
                            aria-label="Event List 7 Days Upcoming"
                            selectionMode="single"
                            selectionStyle="highlight"
                            width={{ base: '100%', L: '100%', M: '100%' }}
                            minHeight={'80px'}
                            maxHeight={{ base: '180px', L: '180px', M: '180px' }}
                            onAction={handleTableRowclick}
                        >
                            <TableHeader columns={isMobile ? columnsDataMobile : columnsData}>
                                {column => (
                                    <Column showDivider key={column.key} width={column?.width}>
                                        {column.name}
                                    </Column>
                                )}
                            </TableHeader>
                            <TableBody
                                items={upComming7DaysEvents}>
                                {item =>
                                    <Row>
                                        {(columnKey: any) => {
                                            if (columnKey === 'edit') {
                                                return (
                                                    <Cell>
                                                        <Flex justifyContent="end">
                                                            <ActionButton
                                                                isQuiet
                                                                aria-label="Edit Event"
                                                                onPress={(e) => {
                                                                    e?.stopPropagation?.();
                                                                    e?.preventDefault?.();
                                                                    handleEditClick && handleEditClick(item);
                                                                }}
                                                            >
                                                                <EditIcon size={22} />
                                                            </ActionButton>
                                                        </Flex>
                                                    </Cell>
                                                );
                                            }
                                            return <Cell>{(item as any)[String(columnKey)]}</Cell>
                                        }
                                        }
                                    </Row>
                                }
                            </TableBody>
                        </TableView>

                    </Flex>
                </>

                <Flex direction={'row'} alignItems={'start'} justifyContent={'start'}>
                    <Content position={'relative'} UNSAFE_className={styles.heading_text}>
                        Past 7 days completed
                    </Content>
                </Flex>
                <Flex direction={'column'}>
                    <TableView
                        UNSAFE_className="tblLayoutComponent"
                        aria-label="Event List 7 Days"
                        selectionMode="single"
                        selectionStyle="highlight"
                        width={{ base: '100%', L: '100%', M: '100%' }}
                        minHeight={'80px'}
                        maxHeight={{ base: '180px', L: '450px', M: '450px' }}
                        onAction={handleTableRowclick}
                    >
                        <TableHeader columns={isMobile ? columnsDataMobile : columnsData}>
                            {column => (
                                <Column showDivider key={column.key} width={column?.width}>
                                    {column.name}
                                </Column>
                            )}
                        </TableHeader>
                        <TableBody
                            items={past7DaysCompleted}>
                            {item =>
                                <Row>
                                    {(columnKey: any) => {
                                        if (columnKey === 'edit') {
                                            return (
                                                <Cell>
                                                    <Flex justifyContent="end">
                                                        <ActionButton
                                                            isQuiet
                                                            aria-label="Edit Event"
                                                            onPress={(e) => {
                                                                e?.stopPropagation?.();
                                                                e?.preventDefault?.();
                                                                handleEditClick && handleEditClick(item);
                                                            }}
                                                        >
                                                            <EditIcon size={22} />
                                                        </ActionButton>
                                                    </Flex>
                                                </Cell>
                                            );
                                        }
                                        return <Cell>{(item as any)[String(columnKey)]}</Cell>
                                    }
                                    }
                                </Row>
                            }
                        </TableBody>
                    </TableView>

                </Flex>
                <Flex direction={'row'} alignItems={'start'} justifyContent={'start'}>
                    <Content position={'relative'} UNSAFE_className={styles.heading_text}>
                        Past 3m un-completed
                    </Content>
                </Flex>
                <Flex UNSAFE_style={{paddingBottom:'10px'}} direction={'column'}>
                    <TableView
                        UNSAFE_className="tblLayoutComponent"
                        aria-label="Event List 3 Months"
                        selectionMode="single"
                        selectionStyle="highlight"
                        width={{ base: '100%', L: '100%', M: '100%' }}
                        minHeight={'80px'}
                        maxHeight={{ base: '1000px', L: '550px' }}
                        onAction={handleTableRowclick}
                    >
                        <TableHeader columns={isMobile ? columnsDataMobile : columnsData}>
                            {column => (
                                <Column showDivider key={column.key} width={column?.width}>
                                    {column.name}
                                </Column>
                            )}
                        </TableHeader>
                        <TableBody
                            items={past3MonthsUnCompleted}>
                            {item =>
                                <Row>
                                    {(columnKey: any) => {
                                        if (columnKey === 'edit') {
                                            return (
                                                <Cell>
                                                    <Flex justifyContent="end">
                                                        <ActionButton
                                                            isQuiet
                                                            aria-label="Edit Event"
                                                            onPress={(e) => {
                                                                e?.stopPropagation?.();
                                                                e?.preventDefault?.();
                                                                handleEditClick && handleEditClick(item);
                                                            }}
                                                        >
                                                            <EditIcon size={22} />
                                                        </ActionButton>
                                                    </Flex>
                                                </Cell>
                                            );
                                        }
                                        return <Cell>{(item as any)[String(columnKey)]}</Cell>
                                    }
                                    }
                                </Row>
                            }
                        </TableBody>
                    </TableView>

                </Flex>
            </Flex>
        );
    }
}

export default EventListTable;
